import React from 'react';
import '../css/PrivacyPage.css';

const PrivacyPage = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-intro">
          At Red Fibre, we respect your privacy and are committed to protecting your personal information. 
          This Privacy Policy outlines how we collect, use, and safeguard your data.
        </p>
        
        <h2 className="privacy-section-title">1. Information We Collect</h2>
        <p className="privacy-text">
          We may collect personal details such as name, email, company name, usage behavior, and uploaded content.
        </p>
        
        <h2 className="privacy-section-title">2. How We Use It</h2>
        <p className="privacy-text">
          Your data helps us improve services, personalize your experience, and communicate updates. 
          We never sell your information.
        </p>
        
        <h2 className="privacy-section-title">3. Data Protection</h2>
        <p className="privacy-text">
          We use encryption, access control, and secure storage to keep your data safe.
        </p>
        
        <h2 className="privacy-section-title">4. Third-Party Services</h2>
        <p className="privacy-text">
          Some tools we use (analytics, storage) may process limited data, under strict agreements.
        </p>
        
        <h2 className="privacy-section-title">5. Your Rights</h2>
        <p className="privacy-text">
          You can request data access, correction, or deletion by contacting us.
        </p>
        
        <h2 className="privacy-section-title">6. Changes</h2>
        <p className="privacy-text">
          We may update this policy as our services evolve. Last updated: July 2025.
        </p>
        
        <p className="privacy-contact">
          For questions, contact us at <span className="privacy-email">privacy@redfibre.in</span>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;